<div class="base tab-content d-flex flex-column" [ngClass]="{ 'hidden' : !newVersion, 'shown' : newVersion  }">
    <div class="title pb-2">{{'New version - reload application' | translate}}</div>
    <img class="reload" src="../../../../content/icons/refresh_white.svg" (click)="reloadAppClick()"/>
</div>
